import { writable } from 'svelte/store';

export const scene = writable("puzzle");
export const userImage = writable("placeholder.png");
